import { inject, Injectable } from '@angular/core'

import { MediaFile } from 'elements-sdk'
import { ModalService } from 'common/util.modals'

import { FileConflictModalComponent } from '../components/fileConflictModal.component'

export interface FileConflictOptions {
  pasteFile: MediaFile
  existingFile: MediaFile
  applyToAll?: boolean
}

export interface ConflictResolution {
  pasteFile: MediaFile
  resolution: 'cancel' | 'skip' | 'overwrite' | 'rename'
  applyToAll: boolean | undefined
}

@Injectable({ providedIn: 'root' })
export class FileConflictService {
  readonly #modal = inject(ModalService)

  show (options: FileConflictOptions): Promise<ConflictResolution> {
    return this.#modal.open(FileConflictModalComponent, options, { notDismissable: true })
  }
}
